
if (typeof Vue === "undefined") {
  const vueScript = document.createElement("script");
  vueScript.src = "https://unpkg.com/vue@2.6.14/dist/vue.min.js";
  vueScript.onload = init;
  document.head.appendChild(vueScript);
} else {
  init();
}

function init() {
  window.addGiftWrap = async function (input) {
    try {
      const variantId = input.value;
      const cart = await fetch("/cart.js").then((r) => r.json());
      const existingWrap = cart.items.find((i) =>
        i.handle.includes("gift-wrapping")
      );

      if (existingWrap) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: existingWrap.key, quantity: 0 }),
        });
      }
 
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      input.checked = false;

      const updated = await fetch("/cart.js").then((r) => r.json());

      const items = updated.items.slice();
      const wrapIndex = items.findIndex((i) =>
        i.handle.includes("gift-wrapping")
      );
      if (wrapIndex > -1) {
        const wrap = items.splice(wrapIndex, 1)[0];
        items.push(wrap);
      }
      const finalCart = {
        ...updated,
        items,
      };
      const cartRoot = document.querySelector('[data-module="header-cart"]');
      const vueCart = cartRoot && cartRoot.__vue__;

      if (!vueCart) {
        console.warn("[GIFTWRAP] No Vue cart instance detected");
        return;
      }

      if (vueCart.$store && vueCart.$store.commit) {
        vueCart.$store.commit("global/refreshCart", finalCart);
      } else if (vueCart.cart) {
        Object.assign(vueCart.cart, finalCart);
      }

      const countEl = document.querySelector(".header-cart__title span");
      if (countEl) countEl.textContent = updated.item_count;
    } catch (err) {
      console.error("[GIFTWRAP ERROR]", err);
    }
  };

  Vue.component("header-cart-giftwrap", {
    props: ["options"],

    methods: {
      priceFormat(price) {
        if (!price) return "";
        const currency =
          (window.Shopify &&
            Shopify.currency &&
            Shopify.currency.active) ||
          __GLOBAL__.currency ||
          "GBP";

        return new Intl.NumberFormat(__GLOBAL__.locale || "en-GB", {
          style: "currency",
          currency,
        })
          .format(price / 100)
          .replace(".00", "");
      },
    },

    template: `
      <div class="cart-gift-wrap">
        <h3 class="p1 black">Packaging Options</h3>

        <div v-for="item in options" :key="item.id" class="gift-wrap-option">
          <label class="gift-wrap-label">
            <input
              class="gift-wrap-input"
              type="radio"
              name="gift_wrap"
              :value="item.id"
              onchange="addGiftWrap(this)"
            >
            <div class="gift-wrap-box jcb aic">
              <div class="f aic gap10">
                <div v-if="item.image"
                    class="gift-wrap-img"
                    :style="{ backgroundImage:'url(' + item.image + ')'}"
                ></div>

                <div class="gift-wrap-info">
                  <p class="p1 black">{{ item.title }}</p>
                  <p class="p1 black" style="font-size:12px;margin-top:5px">
                    {{ item.description }}
                  </p>
                </div>
              </div>

              <span class="gift-wrap-price p1 black">
                {{ priceFormat(item.price) }}
              </span>
            </div>
          </label>
        </div>
      </div>
    `,
  });

  function waitForMount() {
    const el = document.querySelector("#gift-wrap");
    if (!el) return;

    try {
      const data = JSON.parse(el.dataset.options);

      el.innerHTML = `<header-cart-giftwrap :options="options"></header-cart-giftwrap>`;

      window.__giftwrapApp =
        window.__giftwrapApp ||
        new Vue({
          el: "#gift-wrap",
          data: { options: data },
        });

    } catch (e) {
      console.error("[GIFTWRAP] JSON parse error", e);
    }
  }

  waitForMount();
}
